import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { formatCurrency, formatPercentage } from '../../../utils/numberFormatter';
import { NumerosALetras } from 'numero-a-letras';

const PromissoryModal = ({ show, onHide, customerData, financialData }) => {
  // Función para convertir el monto a texto
  const getAmountInWords = (amount) => {
    if (!amount || isNaN(amount)) return '|___|___|';
    
    try {
      // NumerosALetras devuelve en minúsculas, lo convertimos a mayúsculas para el documento legal
      let result = NumerosALetras(amount, {
        plural: 'pesos argentinos',
        singular: 'peso argentino',
        centPlural: 'centavos',
        centSingular: 'centavo'
      }).toUpperCase();
      
      // Quitar "M.N." ya que se especifica que son pesos argentinos en el contexto
      result = result.replace(/\s*M\.N\.?\s*$/i, '');
      
      return result;
    } catch (error) {
      console.error('Error converting amount to words:', error);
      return '';
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="fw-bold">Condiciones del Pagaré</Modal.Title>
        <Button 
          variant="link" 
          onClick={onHide}
          className="p-0 ms-auto"
          style={{ fontSize: '1.5rem', color: '#6c757d' }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </Modal.Header>
      <Modal.Body className="pt-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <div className="promissory-content px-4">
          <div className="text-center mb-4">
            <h4 className="fw-bold">PAGARÉ</h4>
          </div>

          <div className="promissory-text mb-4" style={{ 
            lineHeight: '1.8', 
            textAlign: 'justify',
            textJustify: 'inter-word'
          }}>
            <p className="mb-3">
              A la vista pagaré a WAYNICOIN S.A. (el "Acreedor"), o a su orden, sin protesto, la suma de <span className="text-decoration-underline">{financialData?.amount ? formatCurrency(financialData.amount) : '|___|___|'}</span> (<span className="text-decoration-underline">{getAmountInWords(financialData?.amount)}</span>) más un interés a razón del <span className="text-decoration-underline">{financialData?.interest_rate ? `${formatPercentage(financialData.interest_rate)}` : '|___|___|'}</span> + IVA TNA. Este pagaré es pagadero en el domicilio del Acreedor, Esmeralda 950, Piso 2°, C.A.B.A.
            </p>

            <p className="mb-3">
              En caso de falta de pago a su presentación al cobro, el importe adeudado devengará, además, un interés punitorio de hasta el 150% de la tasa indicada precedentemente. Los intereses punitorios se calcularán exclusivamente sobre el saldo de capital impago.
            </p>

            <p className="mb-3">
              De conformidad con lo dispuesto en el Art. 36 del DECRETO LEY 5965/63, se amplía el plazo de presentación a cinco años a contar de la fecha de libramiento del presente. El librador se somete a la jurisdicción de los Tribunales Ordinarios en lo Comercial de la Ciudad Autónoma de Buenos Aires, o los que en el futuro los reemplacen con igual competencia en razón de la materia y del territorio, o a los correspondientes al domicilio del librador, a opción del Acreedor.
            </p>
          </div>

          <div className="signature-section mb-4 px-2">
            <div className="row">
              <div className="col-6">
                <div className="border-bottom pb-2 mb-3">
                  <strong>FIRMA LIBRADOR</strong>
                </div>
                <div className="text-center" style={{ minHeight: '60px', borderBottom: '1px solid #dee2e6' }}>
                  <span className="text-muted text-decoration-underline">{customerData?.name || '_______'}</span>
                </div>
              </div>
              <div className="col-6">
                <div className="border-bottom pb-2 mb-3">
                  <strong>DNI/CUIT</strong>
                </div>
                <div className="text-center" style={{ minHeight: '60px', borderBottom: '1px solid #dee2e6' }}>
                  <span className="text-muted text-decoration-underline">{customerData?.dni || '_______'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button variant="primary" onClick={onHide} className="w-100">
          Entendido
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PromissoryModal;
